module.exports = __webpack_public_path__ + "img/a.16f0bfbf.png";